module.exports = __webpack_public_path__ + "img/buy-cryptocurrencies.b67f92dc.png";